// eslint-disable-next-line vue/prefer-import-from-vue
import { isPlainObject } from '@vue/shared'

export function merge(object, ...objs) {
    if (!objs?.length) return object
    const ret = object

    for (const obj of objs) {
        for (const k of Object.keys(obj)) {
            ret[k] = isPlainObject(ret[k]) && isPlainObject(obj[k]) ? merge(ret[k], obj[k]) : obj[k]
        }
    }

    return ret
}
